export default __webpack_public_path__ + "static/media/iso-9001-certificate.5205a8eb.png";